import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { VIDEO_QUALITY_MENU, hideContextMenu } from '../contextMenuActions'
import ContextMenu from './ContextMenu'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import MobileDetect from 'aria-viewer/utils/mobileDetect'

class VideoQualityContextMenu extends PureComponent {
    constructor(props) {
        super(props)

        this.selectQuality = this.selectQuality.bind(this)

        this.isMobile = MobileDetect.phone()

        this.style = this.isMobile ? styleguide.contextMenu.dark : styleguide.contextMenu.darkDesktop

        this.state = {
            style: this.style,
        }
    }

    componentDidMount() {
        const heightPerRow = 70
        const availableHeight = this.refs.menu.getWrappedInstance().props.contextMenu.get('y')
        const maxRows = Math.floor(availableHeight / heightPerRow) - 1
        const maxHeight = heightPerRow * maxRows

        const { container, scroller, title } = this.style

        const style = {
            ...this.style,
            container: this.isMobile ? { ...container, width: '9.5em' } : container,
            scroller: { ...scroller, maxHeight },
            title: this.isMobile ? title : { ...title, padding: 10 },
        }

        this.setState({ style })
    }

    selectQuality(e) {
        e.stopPropagation()

        const { videoPlayerSetCurrentQuality, hideContextMenu } = this.props

        const quality = e.target.innerText

        const rendition = this.props.videoQualityOptions.find(video => {
            return video.display == quality
        })

        videoPlayerSetCurrentQuality(rendition.value)
        hideContextMenu()
    }

    render() {
        return (
            <ContextMenu
                ref="menu"
                name={VIDEO_QUALITY_MENU}
                theme={this.state.style}
                onClick={this.selectQuality}
                options={{
                    list: this.props.videoQualityOptions,
                    title: 'Video Quality',
                    selected: this.props.videoQualityOptions.find(quality => {
                        return quality.value == this.props.videoQuality
                    }),
                }}
            />
        )
    }
}

export default connect(
    mapSelectorsToProps(['videoQualityOptions', 'videoQuality']),
    {
        videoPlayerSetCurrentQuality: VideoPlayerActions.setCurrentQuality,
        hideContextMenu,
    }
)(VideoQualityContextMenu)
